import { Modal, ModalBody, ModalHead } from '@dixa/lib-shared-habla';
import type { InstrumentPanel } from 'lib-analytics-types';
import { RefObject } from 'react';

import { InstrumentPanelTitle } from '../../../panel/components/title/instrumentPanelTitle';
import { InstrumentComparison } from '../../instrumentComparison';

import styles from './instrumentComparisonModal.module.scss';

type InstrumentComparisonModalProps = {
  /** The instrument panel. */
  panel: InstrumentPanel;
  /** The ref to the panel DOM element, used to get its measurements. */
  panelRef: RefObject<HTMLDivElement>;
  /** Called when the modal is closed. */
  onClose: () => void;
};

export const InstrumentComparisonModal = ({
  panel,
  panelRef,
  onClose,
}: InstrumentComparisonModalProps): JSX.Element => {
  return (
    <Modal className={styles.modal} isOpen onClose={onClose}>
      <ModalHead
        title={
          <InstrumentPanelTitle panel={panel} data-analytics-panel={panel.id} />
        }
        onClose={onClose}
      />

      <ModalBody>
        <InstrumentComparison panel={panel} panelRef={panelRef} />
      </ModalBody>
    </Modal>
  );
};
